import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.scss';
import App from './App';
import { store } from './store';
import * as Sentry from '@sentry/react';

const enableSentry = () => {
  let env = import.meta.env.VITE_APP_ENV;
  return (env === 'staging' || env === 'prod' || env === 'production' || env === 'qa');
}

Sentry.init({
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_ENV,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.5,
  debug: false,
  enabled: enableSentry(),
});

const container = document.getElementById('root');
const root = createRoot(container!);

// FYI Strict Mode will cause duplicate API calls for
// fetching tax forms.
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
